<template>
  <v-app>
    <NavBar v-if="authenticated"></NavBar>
    <v-content>
      <router-view/>
    </v-content>
    <Snackbar/>
    <v-fade-transition>
      <div class="transitionBG" v-show="transition"></div>
    </v-fade-transition>
    <Profile v-if="authenticated"/>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Snackbar from '@/components/Snackbar.vue'
import Profile from '@/components/Profile.vue'
import { mapGetters, mapActions } from 'vuex' 

export default {
  name: 'App',

  data: () => ({

  }),
  components: {
    NavBar,
    Snackbar,
    Profile
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      transition: 'menu/transition'
    })
  },
  methods: {
    ...mapActions({
      getData: 'data/getData'
    })
  },
  created() {
    if(this.authenticated) {
      this.getData()
    }
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpdateUI = true;
      });
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Pyxel';
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot');
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot?#iefix') format('embedded-opentype'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff2') format('woff2'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff') format('woff'),
      url('~@/assets/fonts/Pyxel-SemiBold.ttf') format('truetype'),
      url('~@/assets/fonts/Pyxel-SemiBold.svg#Pyxel-SemiBold') format('svg');
  font-weight: 600;
  font-style: normal;
}
</style>

<style lang="sass">
.theme--light
  &.v-card 
    background: #e6e6e6
main
  &.v-content
    background: #e6e6e6
.v-toolbar__content
  padding: 4px 30px
.v-toolbar__extension 
  padding: 4px 30px
.comment-content
  &.v-list-item
    &.theme--light
      background: #EDEDED
.quillWrapper 
  background: #EDEDED
  width: 100%
.details
  p
    margin-bottom: 0
.v-text-field
  &.v-text-field--enclosed
    margin: 0
    padding: 0
    border-radius: 0
    .v-text-field__details
      margin: 0
      padding: 0
      height: auto
      min-height: 0
      .v-messages
        margin: 0
        padding: 0
        height: auto
        min-height: 0
.form-row
  margin-bottom: 2px
  background: #5e5e5e
.v-list-item
  .v-list-item__content
    .v-list-item__title
      white-space: inherit
    &.label
      width: 35%
      &+.v-list-item__action
        width: 65%
        &>span
          width: 100%
          .v-input
            .v-messages
              display: block
.theme--dark
  &.v-text-field--solo
    &>.v-input__control
      &>.v-input__slot
        background: #494949
.v-messages
  &.theme--dark
    &.error--text 
      .v-messages__message
        padding: 8px
        background: #df2027
        color: #fff

.filepond--root
  margin-bottom: 0
  
  &>.filepond--panel
    z-index: 2
    border-radius: 0
.filepond--drop-label
    color: #ffffff
    font-family: 'Roboto', sans-serif
.filepond--panel-root
    border-radius: .1em
    background-color: #df2027

@media (max-width: 768px)
  .form-row.v-list-item.theme--light
      flex-wrap: wrap

  .form-row.v-list-item .v-list-item__content.label 
    width: 100%
    padding: 20px 0 0
    flex: auto

  .form-row.v-list-item .v-list-item__content.label+.v-list-item__action
    width: 100%
    margin-left: 0
</style>